
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class OrdersManagementGrid extends _Ext.GridBase<OrdersManagementRow, any> {
        protected getColumnsKey() { return 'ECommerce.OrdersManagement'; }
        protected getDialogType() { return OrdersManagementDialog; }
        protected getIdProperty() { return OrdersManagementRow.idProperty; }
        protected getInsertPermission() { return OrdersManagementRow.insertPermission; }
        protected getLocalTextPrefix() { return OrdersManagementRow.localTextPrefix; }
        protected getService() { return OrdersManagementService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30,  });

            this.toolbar.findButton('add-button').hide();
            this.setTitle("");
            //setTimeout(function () { this.refresh(); }, 2500);
        }

        protected createSlickGrid(): Slick.Grid {
            var grid = super.createSlickGrid();
            grid.setSelectionModel(new Slick.RowSelectionModel());
            return grid;
        }


        protected getColumns() {

            var columns = super.getColumns();
            columns.push(
                {
                    field: 'Action',
                    name: '',
                    format: ctx => '<button class="inline-action btn-success change-status" style="width:100%;">Update</button>',
                    width: 90,
                    minWidth: 90,
                    maxWidth: 90
                });

            return columns;
        }
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();
                if (target.hasClass('change-status')) {
                    
                    var dialg = new OrdersManagementDialog();
                    dialg.loadByIdAndOpenDialog(item.TransId, false);

                    dialg.element.on('dialogclose', () => {                      
                            this.refresh();                        
                    });                    
                }
                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
        }

        protected onDblClick(e: JQueryEventObject, row: number, cell: number) {
            super.onDblClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;
            var item = this.itemAt(row);

            var dialg = new OrdersManagementDialog();
            dialg.loadByIdAndOpenDialog(item.TransId, false);

            dialg.element.on('dialogclose', () => {
                this.refresh();
            });
            
        }

    }
}